import { useState, useMemo } from 'react';

import { useServices } from '@services';
import { ModelTable, Button, SubHeader } from '@component';

import { collection } from './constants';
import { Item } from './Item';

export const CheckList = () => {
  const { db } = useServices();
  const [item, setItem] = useState(null);
  const [updatedOn, setUpdatedOn] = useState(new Date());

  const newItem = {
    title: '',
    text: '',
    order: 0,
  };

  const columns = useMemo(
    () => [
      { Header: 'Title', accessor: 'title' },
      { Header: 'Text', accessor: 'text' },
      { Header: 'Order', accessor: 'order' },
    ],
    []
  );

  return (
    <>
      <SubHeader title="Database Management" seperatorTitle="Checklist" />
      <div className="bg-white p-4 m-4 rounded-md mx-4 items-center">
        <div className="flex justify-end">
          <Button onClick={() => setItem(newItem)}>Add New Checklist</Button>
        </div>
        <ModelTable
          model={{ name: 'Checklist' }}
          collection={collection}
          columns={columns}
          version={updatedOn}
          onViewRow={row => setItem({ ...newItem, ...row })}
          className="mt-4"
          defaultSortBy={[{ id: 'order' }]}
          query={() => db.collection(collection).orderBy('order', 'asc')}
        />
        <Item item={item} close={() => setItem(null)} saved={() => setUpdatedOn(new Date())}></Item>
      </div>
    </>
  );
};
